export default __webpack_public_path__ + "static/logo-8cc5a07bd9b889189cc3a39ce2388b7d.jpeg";